export const hasId = (obj) => {
    return (obj.id !== undefined &&
        (typeof obj.id === 'string' ||
            typeof obj.id === 'number'));
};
//# sourceMappingURL=util.js.map